module.exports = __webpack_public_path__ + "img/clock_schedule.6eacefcc.png";